var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Button, Col, ErrorModal, MessageBanner, Row, } from "@folio/stripes/components";
import { useOkapiKy } from "@folio/stripes/core";
import { zodResolver } from "@hookform/resolvers/zod";
import { Controller, useForm } from "react-hook-form";
import { FormattedMessage, useIntl } from "react-intl";
import { useMutation, useQuery } from "react-query";
import { downloadReportAndSave, generateKult1501Report, generateKult1501Xlsx, } from "../../api/reportsService";
import { fetchLibraries } from "../../api/libraryService";
import { RecekSelect, RecekTextField } from "../../components/inputs";
import { useIsNationalLibrary } from "../../hooks/useIsNationalLibrary";
import { createKult1501ReportSchema } from "../../utils/validationUtils";
import { Kult1501ReportResults } from "./Kult1501ReportResults";
var transformFormToApiParams = function (_a) {
    var formValues = _a.formValues, isNationalLibrary = _a.isNationalLibrary;
    return (__assign({ year: Number(formValues.year) }, (isNationalLibrary && formValues.libraryId
        ? { libraryId: formValues.libraryId }
        : {})));
};
export var Kult1501ReportForm = function () {
    var _a;
    var formatMessage = useIntl().formatMessage;
    var kyInstance = useOkapiKy();
    var _b = useState(null), feedback = _b[0], setFeedback = _b[1];
    var _c = useIsNationalLibrary(), activeLibraryId = _c.activeLibraryId, isNationalLibrary = _c.isNationalLibrary, isActiveLibraryLoading = _c.isLoading;
    var _d = useQuery(["outputs-recipient-libraries"], function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, fetchLibraries(kyInstance, {
                        limit: 100,
                        offset: 0,
                    })];
                case 1:
                    response = _b.sent();
                    return [2 /*return*/, __spreadArray([], ((_a = response.items) !== null && _a !== void 0 ? _a : []), true).sort(function (firstLibrary, secondLibrary) {
                            var _a, _b;
                            return ((_a = firstLibrary.name) !== null && _a !== void 0 ? _a : "").localeCompare((_b = secondLibrary.name) !== null && _b !== void 0 ? _b : "", "cs");
                        })
                            .map(function (library) {
                            var _a, _b;
                            return ({
                                value: (_a = library.id) !== null && _a !== void 0 ? _a : "",
                                label: (_b = library.name) !== null && _b !== void 0 ? _b : "",
                            });
                        })];
            }
        });
    }); }, { enabled: isNationalLibrary, staleTime: 60 * 60 * 1000 }), _e = _d.data, libraryOptions = _e === void 0 ? [] : _e, areLibrariesLoading = _d.isLoading;
    var _f = useForm({
        resolver: zodResolver(createKult1501ReportSchema(formatMessage)),
        defaultValues: {
            year: String(new Date().getFullYear()),
            libraryId: "",
        },
        mode: "onSubmit",
        shouldFocusError: false,
    }), control = _f.control, handleSubmit = _f.handleSubmit, setValue = _f.setValue, errors = _f.formState.errors;
    useEffect(function () {
        setValue("libraryId", isNationalLibrary ? activeLibraryId : "");
    }, [activeLibraryId, isNationalLibrary, setValue]);
    var _g = useMutation(function (variables) {
        return generateKult1501Report(kyInstance, transformFormToApiParams(variables));
    }, {
        onMutate: function () { return setFeedback(null); },
        onSuccess: function () {
            return setFeedback({
                type: "success",
                message: formatMessage({
                    id: "ui-br-legaldeposits.outputs.kult-15-01.success.preview",
                }),
            });
        },
        onError: function () {
            return setFeedback({
                type: "error",
                message: formatMessage({
                    id: "ui-br-legaldeposits.outputs.kult-15-01.error.generate",
                }),
            });
        },
    }), generatePreview = _g.mutate, isPreviewLoading = _g.isLoading, reportData = _g.data;
    var _h = useMutation(function (variables) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, generateKult1501Xlsx(kyInstance, transformFormToApiParams(variables))];
                case 1:
                    response = _a.sent();
                    if (!response.fileId || !response.fileName) {
                        throw new Error("Missing report download metadata");
                    }
                    return [4 /*yield*/, downloadReportAndSave(kyInstance, response.fileId, response.fileName)];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, {
        onMutate: function () { return setFeedback(null); },
        onSuccess: function () {
            return setFeedback({
                type: "success",
                message: formatMessage({
                    id: "ui-br-legaldeposits.outputs.kult-15-01.success.xlsx",
                }),
            });
        },
        onError: function () {
            return setFeedback({
                type: "error",
                message: formatMessage({
                    id: "ui-br-legaldeposits.outputs.kult-15-01.error.generate",
                }),
            });
        },
    }), generateXlsx = _h.mutate, isXlsxLoading = _h.isLoading;
    var isGenerating = isPreviewLoading || isXlsxLoading;
    var isFormDisabled = isGenerating || isActiveLibraryLoading;
    var handlePreviewSubmit = useCallback(function (event) {
        handleSubmit(function (formValues) {
            return generatePreview({ formValues: formValues, isNationalLibrary: isNationalLibrary });
        })(event);
    }, [generatePreview, handleSubmit, isNationalLibrary]);
    var handleDownloadXlsx = useCallback(function () {
        handleSubmit(function (formValues) {
            return generateXlsx({ formValues: formValues, isNationalLibrary: isNationalLibrary });
        })();
    }, [generateXlsx, handleSubmit, isNationalLibrary]);
    var dismissFeedback = useCallback(function () { return setFeedback(null); }, []);
    var recipientLibraryOptions = useMemo(function () { return __spreadArray([
        {
            value: "",
            label: formatMessage({
                id: "ui-br-legaldeposits.outputs.kult-15-01.field.library.placeholder",
            }),
        }
    ], libraryOptions, true); }, [formatMessage, libraryOptions]);
    return (React.createElement(React.Fragment, null,
        React.createElement("form", { onSubmit: handlePreviewSubmit },
            React.createElement("h2", null,
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.outputs.report.kult-15-01" })),
            React.createElement("p", null,
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.outputs.kult-15-01.description" })),
            React.createElement(Row, null,
                React.createElement(Col, { xs: 12, md: 4 },
                    React.createElement(Controller, { control: control, name: "year", render: function (_a) {
                            var _b;
                            var field = _a.field;
                            return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-legaldeposits.outputs.kult-15-01.field.year", required: true, error: (_b = errors.year) === null || _b === void 0 ? void 0 : _b.message })));
                        } })),
                isNationalLibrary && (React.createElement(Col, { xs: 12, md: 8 },
                    React.createElement(Controller, { control: control, name: "libraryId", render: function (_a) {
                            var field = _a.field;
                            return (React.createElement(RecekSelect, __assign({}, field, { labelId: "ui-br-legaldeposits.outputs.kult-15-01.field.library", dataOptions: recipientLibraryOptions, disabled: areLibrariesLoading || isGenerating })));
                        } })))),
            React.createElement(Row, null,
                React.createElement(Col, { xs: 12 },
                    React.createElement(Button, { type: "submit", buttonStyle: "primary", disabled: isFormDisabled }, isGenerating
                        ? formatMessage({
                            id: "ui-br-legaldeposits.outputs.button.generating",
                        })
                        : formatMessage({
                            id: "ui-br-legaldeposits.outputs.kult-15-01.button.preview",
                        })),
                    React.createElement(Button, { type: "button", onClick: handleDownloadXlsx, disabled: isFormDisabled },
                        React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.outputs.kult-15-01.button.downloadXlsx" })))),
            (feedback === null || feedback === void 0 ? void 0 : feedback.type) === "success" && (React.createElement(MessageBanner, { dismissible: true, onExited: dismissFeedback, type: "success" }, feedback.message)),
            React.createElement(ErrorModal, { open: (feedback === null || feedback === void 0 ? void 0 : feedback.type) === "error", label: formatMessage({
                    id: "ui-br-legaldeposits.error.modal.title",
                }), content: (_a = feedback === null || feedback === void 0 ? void 0 : feedback.message) !== null && _a !== void 0 ? _a : "", onClose: dismissFeedback })),
        reportData && React.createElement(Kult1501ReportResults, { data: reportData })));
};
